"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageIdForActiveXfer = exports.isAsperaInitializing = exports.isAsperaEnabled = exports.isAsperaLoaded = exports.getTotalSizeOfStagedFiles = void 0;
var getTotalSizeOfStagedFiles = function (state) {
    var currentTotalSize = state.transfers.stagedFiles.map(function (f) { return f.size; }).reduce(function (prev, curr) { return prev + curr; }, 0);
    return currentTotalSize;
};
exports.getTotalSizeOfStagedFiles = getTotalSizeOfStagedFiles;
var isAsperaLoaded = function (state) {
    return state.transfers.connectStatus === 'RUNNING'
        || state.transfers.connectStatus === 'FAILED'
        || state.transfers.connectStatus === 'OUTDATED';
};
exports.isAsperaLoaded = isAsperaLoaded;
var isAsperaEnabled = function (state) {
    return state.transfers.connectStatus === 'RUNNING' || state.transfers.connectStatus === 'OUTDATED';
};
exports.isAsperaEnabled = isAsperaEnabled;
var isAsperaInitializing = function (state) {
    return ['INITIALIZING', 'RETRYING'].includes(state.transfers.connectStatus);
};
exports.isAsperaInitializing = isAsperaInitializing;
var getPackageIdForActiveXfer = function (state, requestId) {
    var activeXfer = state.transfers.activeTransfers.find(function (t) { return t.requestId === requestId; });
    return activeXfer ? activeXfer.packageId : undefined;
};
exports.getPackageIdForActiveXfer = getPackageIdForActiveXfer;
